const Testing = () => {
  return (
    <div>
      <h1>Testing</h1>
    </div>
  )
}

export default Testing
